let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("0CAU1")).then(() => parcelRequire('1LwF8'));